import React from 'react';
import moment from 'moment';
import InvoiceTypes from '../../util/InvoiceTypes';
import * as Price from '../../util/Price';
import '../../assets/fonts/Poppins-SemiBold-normal';
import logo from '../../assets/images/cto-full-logo.png';
import './invoiceTemplate.css';

const InvoicePdfTemplate = ({ invoice, org }) => {
  return (

    <div className="container">
      <div className="section">
        <div className="logo-section">
          <img className="logo-image" alt="logo" src={logo} />
          <div className="invoice-heading">Invoice</div>
          <div className="row">
            <div className="subheading">Invoice Number : {invoice.invoiceNumber}</div>
          </div>
        </div>
        <div className="address-section">
          <div className="subheading">Check This Out LLC</div>
          <div className="subheading">PO Box 1805</div>
          <div className="subheading">Bozeman, MT 59771</div>
          <div className="subheading">United States</div>
          <div className="subheading">Federal Tax ID: 84-4589740</div>
        </div>
      </div>
      <div className="section">
        <div className="logo-section">
          <div className="heading">Bill To</div>
          <div className="subheading">{`${org?.ownerName}`}</div>
        </div>
      </div>
      <div className="section">
        <div className="logo-section">
          {invoice.type === InvoiceTypes.MonthlyPayment ? (
            <>
              <div className="heading">Billing-period</div>
              <div className="subheading">
                {' '}
                {`${moment(
                  (invoice.subscriptionCycleStartDate || invoice.paidAt) * 1000,
                ).format('MM/D/YYYY')} - ${moment(
                  invoice.subscriptionCycleEndDate * 1000,
                ).format('MM/D/YYYY')}`}
              </div>
            </>
          ) : (
            <>
              <div className="heading">Date : {moment(invoice.paidAt * 1000).format('MM/D/YYYY')}</div>

            </>
          )}
        </div>
      </div>

      <div className="section">
        <div className="logo-section">
          <div className="heading">Invoice details</div>
          <div className="row">
            <div className="subheading">Invoice number : {invoice.invoiceNumber}</div>
          </div>
          <div className="row">
            <div className="subheading">Invoice date : {`${moment(
              (invoice.subscriptionCycleEndDate || invoice.paidAt) * 1000,
            ).format('MM/D/YYYY')}`}
            </div>
          </div>
          <div className="row">
            <div className="subheading">Invoice total : {`$${Price.output(
              invoice.totalAmountDue + invoice.additionalAmount || 0,
              true,
            )}`}
            </div>
          </div>
          <div className="row">
            <div className="subheading">Invoice status : {invoice.paidAt ? 'Paid' : 'Not yet paid'}</div>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="usage-summary-section">

          <div className="heading">Usage summary</div>
          <div className="subheading">Description : {invoice.description}</div>

          {invoice.type === InvoiceTypes.MonthlyPayment && (
            <>
              <h3 className="heading-md">
                Referral Marketing : $
                {Price.output(
                  invoice.newCustomerCost + invoice.repeatCustomerCost,
                  true,
                )}
              </h3>
              <div className="row">
                <div className="subheading">
                  - New Customer contacts acquired :  {`${invoice.newCustomerAmount}`} (discount activations)
                </div>

              </div>
              <div className="row">
                <div className="subheading">- Repeat Customers : {`${invoice.repeatCustomerAmount}`} (discount activations)</div>

              </div>
              <div className="heading-md">
                Campaign Marketing : $
                {Price.output(invoice.campaignCharges, true)}
              </div>
              {invoice.campaignStats.sms.creditUsed > 0 && (
                <div className="row">
                  <div className="subheading">
                    - {invoice.campaignStats.sms.creditUsed} credits for{' '}
                    {invoice.campaignStats.sms.numberSent} SMS
                  </div>
                </div>
              )}

              {invoice.campaignStats.mms.creditUsed > 0 && (
                <div className="row">
                  <div className="subheading">
                    - {invoice.campaignStats.mms.creditUsed} credits for{' '}
                    {invoice.campaignStats.mms.numberSent} MMS
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className="section" />
      <div className="section">
        <div className="summary-section">
          <div className="summary-row">
            <div className="heading">
              {invoice.type === InvoiceTypes.MonthlyPayment ? (
                <>
                  Summary for{' '}
                  {`${moment(
                    (invoice.subscriptionCycleStartDate || invoice.paidAt)
                    * 1000,
                  ).format('MM/D/YYYY')} - ${moment(
                    invoice.subscriptionCycleEndDate * 1000,
                  ).format('MM/D/YYYY')}`}
                </>
              ) : (
                <>Summary :</>
              )}
            </div>
          </div>

          <div className="summary-row">
            <div className="subheading">Total Service Charges : </div>
            <div className="subheading">{`$${Price.output(
              invoice.totalAmountDue,
              true,
            )}`}
            </div>
          </div>

          {invoice.organizationMinMonthlyCharges > invoice.totalAmountDue
            ? (
              <div className="summary-row">
                <div className="subheading">Minimum Monthly Charge :</div>
                <div className="subheading">{`$${Price.output(
                  invoice.organizationMinMonthlyCharges,
                  true,
                )}`}
                </div>
              </div>
            )
            : null}

          <div className="summary-row">
            <div className="subheading">Tax(0%) :</div>
            <div className="subheading">$0.00</div>
          </div>
          <div className="summary-row">
            <div className="subheading">Total Billed Amount :</div>
            <div className="subheading">{`$${Price.output(
              invoice.totalAmountDue + invoice.additionalAmount,
              true,
            )}`}
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="footer-section">
          <div className="subheading">
            You will automatically be charged for any amount due.
          </div>
          <div className="subheading">Thank you for your business!</div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePdfTemplate;
